import script from "./NavbarLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./NavbarLayout.vue?vue&type=script&setup=true&lang=js"

import "./NavbarLayout.vue?vue&type=style&index=0&id=456dbe68&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-456dbe68"]])

export default __exports__